import { UserRolesEnum } from '@sparling/financial-common'

export interface IUserPermissions {
  value: string
  label: string
}

export enum userPermissionEnum {
  admin = 'admin',
  executor = 'executor',
  accountant = 'accountant',
  viewer = 'viewer',
  // eslint-disable-next-line camelcase
  sole_trader = 'sole_trader',
}

export function getReadableUserRole(role: string): string {
  switch (role) {
    case UserRolesEnum.ADMIN:
      return UserRolesEnum.ADMIN
    case UserRolesEnum.SOLE_TRADER:
      return UserRolesEnum.SOLE_TRADER
    case UserRolesEnum.UBO:
      return UserRolesEnum.VIEWER
    case UserRolesEnum.DIRECTOR:
      return UserRolesEnum.VIEWER
    case UserRolesEnum.UBO_EXECUTOR:
      return UserRolesEnum.EXECUTOR
    case UserRolesEnum.DIRECTOR_EXECUTOR:
      return UserRolesEnum.EXECUTOR
    default:
      return role
  }
}

type PropsUserPermission = {
  [key: string]: string[]
}

export const USER_PERMISSIONS: PropsUserPermission = {
  [userPermissionEnum.admin]: [
    'Request quotes',
    'Execute trades',
    'Manage crypto addresses',
    'Manage bank accounts',
    'Request settlements',
    'View past trades',
    'View balance activity',
    'View crypto addresses',
    'View bank account info',
    'Manage users',
    'Manage KYC status',
  ],
  [userPermissionEnum.sole_trader]: [
    'Request quotes',
    'Execute trades',
    'Manage crypto addresses',
    'Manage bank accounts',
    'Request settlements',
    'View past trades',
    'View balance activity',
    'View crypto addresses',
    'View bank account info',
    'Manage KYC status',
  ],
  [userPermissionEnum.executor]: [
    'Request quotes',
    'Execute trades',
    'View past trades',
    'View balance activity',
    'Manage KYC status',
  ],
  [userPermissionEnum.accountant]: [
    'Manage crypto addresses',
    'Manage bank accounts',
    'Request settlements',
    'View past trades',
    'View balance activity',
    'View crypto addresses',
    'View bank account info',
    'Manage KYC status',
  ],
  [userPermissionEnum.viewer]: [
    'View past trades',
    'View balance activity',
    'View crypto addresses',
    'View bank account info',
    'Manage KYC status',
  ],
}
